import MDReader from "./Wiki/MDReader";

export default function ModelCijfers() {
  return (
      <div className="modelcijfers">
         <MDReader title="Model in Cijfers" file={`./modelcijfers/model_in_cijfers.md`} />
      </div>
  );
};
